__turbopack_context__.v({
  "reviewsTabs": "reviews-module-scss-module__Upvqua__reviewsTabs",
  "reviewsTabs_tab": "reviews-module-scss-module__Upvqua__reviewsTabs_tab",
  "reviewsTabs_tabList": "reviews-module-scss-module__Upvqua__reviewsTabs_tabList",
  "reviewsTabs_tabPanel": "reviews-module-scss-module__Upvqua__reviewsTabs_tabPanel",
});
